






































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { ActivitiesListModule } from '@/store/modules/activitiesList';
import Alert from '@/components/Shared/Alert.vue';
import ActivityDetailPane from '@/components/Activities/ActivityDetailPane.vue';
import ActivitySidePanel from '@/components/Activities/ActivitySidePanel.vue';
import ActivityStatusDisplay from '@/components/Activities/Display/ActivityStatus.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import ActivityType, { ActivityTypeLabels, ActivityTypeIcons } from '@/models/Activities/ActivityType';
import ActivityStatus, { ActivityStatusLabels } from '@/models/Activities/ActivityStatus';
import ActivityDirection from '@/models/Activities/ActivityDirection';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';
import ActivityDto from '@/models/Activities/ActivityDto';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import PageNames from '@/router/PageNames';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import OpenEntityInNewWindowBtn from '@/components/Shared/OpenEntityInNewWindowBtn.vue';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';
import UserType from '@/models/Users/UserType';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';

@Component({
  name: 'Activities',
  components: { Alert, ActivityDetailPane, ActivitySidePanel, ActivityStatusDisplay, OpenEntityInNewWindowBtn, TaskGrid }
})
export default class Activities extends GiganautVue {
  EntityType = EntityType;
  ComponentLocation = ComponentLocation;
  ActivityType = ActivityType;
  ActivityTypeIcons = ActivityTypeIcons;
  ActivityStatus = ActivityStatus;
  ActivityDirection = ActivityDirection;
  StatusDisplayLocation = StatusDisplayLocation;

  // View mode: 'tasks' (default) or 'all'
  viewMode: 'tasks' | 'all' = 'tasks';

  // Applied filters (what is currently used for API calls)
  selectedStatus: number = ActivityStatus.Completed;
  selectedOwner: AgencyUserDto | null = null;
  selectedBranch: BranchDto | null = null;
  selectedDesk: DeskDto | null = null;

  // Filter dialog working state (edited before applying)
  filterStatus: number = ActivityStatus.Completed;
  filterOwner: AgencyUserDto | null = null;
  filterBranch: BranchDto | null = null;
  filterDesk: DeskDto | null = null;

  // Task filter state (read from TaskGrid via events)
  taskFilterStatus: number = ActivityStatus.Planned;
  taskFilterOwner: AgencyUserDto | null = null;
  taskFilterBranch: BranchDto | null = null;
  taskFilterDesk: DeskDto | null = null;

  // Master-detail selection state
  selectedActivityId: string | null = null;

  // Side panel state (for create/edit only)
  sidePanelVisible = false;
  editingActivity: ActivityDto | null = null;
  createMode = false;
  createActivityType: ActivityType | null = null;
  createActivityDirection: ActivityDirection | null = null;
  deleteDialogVisible = false;
  deletingActivity: ActivityDto | null = null;
  deleting = false;

  // Follow-up activity context
  createFromActivity: ActivityDto | null = null;

  // Reply state
  replyToActivity: ActivityDto | null = null;
  replyAll = false;
  isChase = false;

  // Filter dialog
  activityFilterDialogVisible = false;

  // Multi-select
  selectedActivities: ActivityDto[] = [];
  taskSelections: ActivityDto[] = [];
  bulkUpdating = false;

  // Non-task activity types (tasks have their own dedicated view via TaskGrid)
  readonly nonTaskTypes = [ActivityType.Note, ActivityType.Call, ActivityType.Meeting, ActivityType.Email];

  // Pagination
  pageSize = 20;
  currentPage = 1;
  loadingMore = false;

  // Headers - compact for master-detail layout
  tableHeaders = [
    { text: 'Subject', value: 'subject' },
    { text: 'Completed At/By', value: 'completedAtBy', width: '220px', sortable: false },
    { text: 'Related To', value: 'relatedTo', width: '180px', sortable: false }
  ];

  get currentHeaders() {
    return this.tableHeaders;
  }

  get statusOptions() {
    return [
      { value: ActivityStatus.Completed, label: ActivityStatusLabels[ActivityStatus.Completed] },
      { value: ActivityStatus.Draft, label: ActivityStatusLabels[ActivityStatus.Draft] }
    ];
  }

  get activeAgencyUsers(): AgencyUserDto[] {
    return AgencySettingsModule.agencyUsers.filter(
      user => user.status === AgencyUserStatus.Active
    );
  }

  get branches(): BranchDto[] {
    return AgencySettingsModule.branches;
  }

  get filterDesks(): DeskDto[] {
    if (this.filterBranch) {
      return this.filterBranch.desks;
    }
    return [];
  }

  agencyUserDisplayName(item: AgencyUserDto): string {
    return item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  get loading() {
    return ActivitiesListModule.loading;
  }

  get activities() {
    return ActivitiesListModule.activities;
  }

  get totalCount() {
    return ActivitiesListModule.totalCount;
  }

  get hasMore() {
    return this.activities.length < this.totalCount;
  }

  get selectedDetailActivity(): ActivityDto | null {
    if (!this.selectedActivityId) return null;
    return this.activities.find(a => a.id === this.selectedActivityId) || null;
  }

  async created() {
    // Load agency users and branches for filter dropdowns
    if (AgencySettingsModule.agencyUsers.length === 0) {
      await AgencySettingsModule.getAgencyUsers();
    }
    if (AgencySettingsModule.branches.length === 0) {
      await AgencySettingsModule.getBranches();
    }

    // Pre-set the owner filter to the current user (agency users only, not sysadmins)
    if (AppModule.userProfile && AppModule.userProfile.userType === UserType.Agency && AppModule.userProfile.agencyUserId) {
      const currentAgencyUser = AgencySettingsModule.agencyUsers.find(u => u.id === AppModule.userProfile.agencyUserId);
      if (currentAgencyUser) {
        this.selectedOwner = currentAgencyUser;
        this.filterOwner = currentAgencyUser;
      }
    }

    // Default status filter
    this.selectedStatus = ActivityStatus.Completed;
    this.filterStatus = ActivityStatus.Completed;
    // Only load activities list data when starting in all-activities mode
    // Tasks mode is handled entirely by the TaskGrid component
    if (this.viewMode === 'all') {
      await this.loadActivities(true);
    }
  }

  @Watch('viewMode')
  onViewModeChange() {
    // When switching to other activities, load data. Tasks mode is handled by TaskGrid.
    if (this.viewMode === 'all') {
      this.loadActivities(true);
    }
  }

  @Watch('filterBranch')
  onFilterBranchChange(val: BranchDto | null) {
    if (!val) {
      this.filterDesk = null;
    }
  }

  openActivityFilters() {
    // Sync working state from applied state before opening dialog
    this.filterStatus = this.selectedStatus;
    this.filterOwner = this.selectedOwner;
    this.filterBranch = this.selectedBranch;
    this.filterDesk = this.selectedDesk;
    this.activityFilterDialogVisible = true;
  }

  applyActivityFilters() {
    this.activityFilterDialogVisible = false;
    this.selectedStatus = this.filterStatus;
    this.selectedOwner = this.filterOwner;
    this.selectedBranch = this.filterBranch;
    this.selectedDesk = this.filterDesk;
    this.loadActivities(true);
  }

  async loadActivities(reset = false) {
    if (reset) {
      this.selectedActivities = [];
    }
    this.currentPage = 1;
    const ownerIds = this.selectedOwner ? [this.selectedOwner.id] : [];
    const branchIds = this.selectedBranch ? [this.selectedBranch.id] : [];
    const deskIds = this.selectedDesk ? [this.selectedDesk.id] : [];
    await ActivitiesListModule.loadActivities({
      page: 1,
      pageSize: this.pageSize,
      activityTypes: [...this.nonTaskTypes],
      statuses: [this.selectedStatus],
      ownerIds: ownerIds,
      branchIds: branchIds,
      deskIds: deskIds
    });
  }

  async loadMore() {
    this.loadingMore = true;
    try {
      this.currentPage++;
      const ownerIds = this.selectedOwner ? [this.selectedOwner.id] : [];
      const branchIds = this.selectedBranch ? [this.selectedBranch.id] : [];
      const deskIds = this.selectedDesk ? [this.selectedDesk.id] : [];
      await ActivitiesListModule.loadMoreActivities({
        page: this.currentPage,
        pageSize: this.pageSize,
        activityTypes: [...this.nonTaskTypes],
        statuses: [this.selectedStatus],
        ownerIds: ownerIds,
        branchIds: branchIds,
        deskIds: deskIds
      });
    } finally {
      this.loadingMore = false;
    }
  }

  getTypeName(type: number, direction: number | null): string {
    if (type === ActivityType.Email) {
      if (direction === 2) return 'Inbound Email';
      if (direction === 1) return 'Outbound Email';
    }
    if (type === ActivityType.Call) {
      if (direction === 2) return 'Inbound Call';
      if (direction === 1) return 'Outbound Call';
    }
    return ActivityTypeLabels[type] || 'Unknown';
  }

  getTypeIcon(type: number, direction: number | null): string {
    if (type === ActivityType.Email) {
      if (direction === 2) return this.IconConstants.EmailIncoming;
      if (direction === 1) return this.IconConstants.EmailOutgoing;
      return this.IconConstants.Email;
    }
    if (type === ActivityType.Call) {
      if (direction === 2) return this.IconConstants.PhoneIncoming;
      if (direction === 1) return this.IconConstants.PhoneOutgoing;
      return this.IconConstants.PhoneCall;
    }
    return ActivityTypeIcons[type] || this.IconConstants.Note;
  }

  getTypeColor(type: number): string {
    switch (type) {
      case ActivityType.Note: return 'grey';
      case ActivityType.Task: return 'orange';
      case ActivityType.Call: return 'green';
      case ActivityType.Meeting: return 'purple';
      case ActivityType.Email: return 'blue';
      default: return 'grey';
    }
  }

  getPriorityLabel(priority: number | null): string {
    if (!priority) return '-';
    switch (priority) {
      case 1: return 'Low';
      case 2: return 'Normal';
      case 3: return 'High';
      case 4: return 'Urgent';
      default: return '-';
    }
  }

  getPriorityColor(priority: number | null): string {
    if (!priority) return '';
    switch (priority) {
      case 1: return 'blue--text';
      case 2: return 'green--text';
      case 3: return 'orange--text';
      case 4: return 'red--text';
      default: return '';
    }
  }

  getEntityIcon(entityType: number): string {
    switch (entityType) {
      case ActivityEntityType.Company: return this.IconConstants.Company;
      case ActivityEntityType.Location: return this.IconConstants.Location;
      case ActivityEntityType.Contact: return this.IconConstants.Contact;
      case ActivityEntityType.Worker: return this.IconConstants.Worker;
      case ActivityEntityType.Job: return this.IconConstants.Job;
      case ActivityEntityType.Booking: return this.IconConstants.Booking;
      case ActivityEntityType.Opportunity: return this.IconConstants.Opportunity;
      default: return this.IconConstants.Activity;
    }
  }

  getEntityRoute(item: ActivityDto): string {
    switch (item.primaryEntityType) {
      case ActivityEntityType.Company: return `/agency/companies/${item.companyId}`;
      case ActivityEntityType.Location: return `/agency/locations/${item.locationId}`;
      case ActivityEntityType.Contact: return `/agency/contacts/${item.contactId}`;
      case ActivityEntityType.Worker: return `/agency/workers/${item.workerId}`;
      case ActivityEntityType.Job: return `/agency/jobs/${item.jobId}`;
      case ActivityEntityType.Booking: return `/agency/bookings/${item.bookingId}`;
      case ActivityEntityType.Opportunity: return `/agency/opportunities/${item.opportunityId}`;
      default: return '';
    }
  }

  getEntityId(item: ActivityDto): string {
    switch (item.primaryEntityType) {
      case ActivityEntityType.Company: return item.companyId || '';
      case ActivityEntityType.Location: return item.locationId || '';
      case ActivityEntityType.Contact: return item.contactId || '';
      case ActivityEntityType.Worker: return item.workerId || '';
      case ActivityEntityType.Job: return item.jobId || '';
      case ActivityEntityType.Booking: return item.bookingId || '';
      case ActivityEntityType.Opportunity: return item.opportunityId || '';
      default: return '';
    }
  }

  getEntityTypeForBtn(entityType: number): number {
    switch (entityType) {
      case ActivityEntityType.Company: return EntityType.Company;
      case ActivityEntityType.Location: return EntityType.Location;
      case ActivityEntityType.Contact: return EntityType.Contact;
      case ActivityEntityType.Worker: return EntityType.Worker;
      case ActivityEntityType.Job: return EntityType.Job;
      case ActivityEntityType.Booking: return EntityType.Booking;
      case ActivityEntityType.Opportunity: return EntityType.Opportunity;
      default: return EntityType.Contact;
    }
  }

  onRowClick(item: ActivityDto) {
    this.selectedActivityId = item.id;
  }

  onEditFromDetail(activity: ActivityDto) {
    this.editingActivity = activity;
    this.createMode = false;
    this.createActivityType = null;
    this.sidePanelVisible = true;
  }

  onResumeDraft(activity: ActivityDto) {
    this.editingActivity = activity;
    this.createMode = false;
    this.createActivityType = null;
    this.sidePanelVisible = true;
  }

  async onCompleteFromDetail(activity: ActivityDto) {
    try {
      await ajax.put(`/api/v1/agency/activities/${activity.id}/status`, {
        status: ActivityStatus.Completed,
        updatedAt: activity.updatedAt
      });
      await this.loadActivities(true);
    } catch (error) {
      AppModule.handleApiError(error);
    }
  }

  onReply(payload: { activity: ActivityDto; replyAll: boolean; chase?: boolean }) {
    this.editingActivity = null;
    this.createMode = true;
    this.createActivityType = ActivityType.Email;
    this.createActivityDirection = null;
    this.createFromActivity = null;
    this.replyToActivity = payload.activity;
    this.replyAll = payload.replyAll;
    this.isChase = payload.chase || false;
    this.sidePanelVisible = true;
  }

  onCreateTask(activity: ActivityDto) {
    this.editingActivity = null;
    this.createMode = true;
    this.createActivityType = ActivityType.Task;
    this.createFromActivity = activity;
    this.sidePanelVisible = true;
  }

  openCreatePanel(activityType: ActivityType) {
    this.editingActivity = null;
    this.createMode = true;
    this.createActivityType = activityType;
    this.createActivityDirection = null;
    this.sidePanelVisible = true;
  }

  openCreateCallPanel(direction: ActivityDirection) {
    this.editingActivity = null;
    this.createMode = true;
    this.createActivityType = ActivityType.Call;
    this.createActivityDirection = direction;
    this.sidePanelVisible = true;
  }

  closeSidePanel() {
    this.sidePanelVisible = false;
    this.editingActivity = null;
    this.createMode = false;
    this.createActivityType = null;
    this.createActivityDirection = null;
    this.createFromActivity = null;
    this.replyToActivity = null;
    this.replyAll = false;
    this.isChase = false;
  }

  openEditMode(activity: ActivityDto) {
    // Side panel handles edit mode internally
  }

  openDeleteDialog(activity: ActivityDto) {
    this.deletingActivity = activity;
    this.deleteDialogVisible = true;
  }

  async onActivitySaved() {
    this.closeSidePanel();
    await this.loadActivities(true);
  }

  async onActivityUpdated() {
    await this.loadActivities(true);
  }

  async confirmDelete() {
    if (!this.deletingActivity) return;
    this.deleting = true;
    try {
      const deletedId = this.deletingActivity.id;
      await ajax.delete(`/api/v1/agency/activities/${deletedId}`);
      this.deleteDialogVisible = false;
      this.deletingActivity = null;
      if (this.selectedActivityId === deletedId) {
        this.selectedActivityId = null;
      }
      this.closeSidePanel();
      await this.loadActivities(true);
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.deleting = false;
    }
  }

  clearSelection() {
    this.selectedActivities = [];
  }

  onTaskSelectionChange(tasks: ActivityDto[]) {
    this.taskSelections = tasks;
  }

  onTaskFilterChange(filters: { status: number; owner: AgencyUserDto | null; branch: BranchDto | null; desk: DeskDto | null }) {
    this.taskFilterStatus = filters.status;
    this.taskFilterOwner = filters.owner;
    this.taskFilterBranch = filters.branch;
    this.taskFilterDesk = filters.desk;
  }

  openTaskFilters() {
    const taskGrid = this.$refs.taskGrid as any;
    if (taskGrid) {
      taskGrid.openFilters();
    }
  }

  openCreateTaskFromToolbar() {
    const taskGrid = this.$refs.taskGrid as any;
    if (taskGrid) {
      taskGrid.openCreateTask();
    }
  }

  clearTaskSelection() {
    const taskGrid = this.$refs.taskGrid as any;
    if (taskGrid) {
      taskGrid.selectedTasks = [];
    }
  }

  async bulkSetTaskStatus(status: ActivityStatus) {
    const taskGrid = this.$refs.taskGrid as any;
    if (taskGrid) {
      await taskGrid.bulkSetStatus(status);
    }
  }

  getInitials(person: { firstName?: string; lastName?: string }): string {
    const first = person.firstName ? person.firstName.charAt(0).toUpperCase() : '';
    const last = person.lastName ? person.lastName.charAt(0).toUpperCase() : '';
    return first + last;
  }

  getOwnerAvatarUrl(owner: { id?: string; avatar?: string }): string {
    if (!owner.avatar || !owner.id) return '';
    const baseUrl = AppModule.currentAgencyContext?.storageSharedBaseUrl;
    if (!baseUrl) return '';
    return `${baseUrl}/avatars/2/${owner.id}/resized-100/${owner.avatar}`;
  }

  async bulkSetStatus(status: ActivityStatus) {
    if (this.selectedActivities.length === 0) return;

    this.bulkUpdating = true;
    try {
      const promises = this.selectedActivities.map(activity =>
        ajax.put(`/api/v1/agency/activities/${activity.id}/status`, {
          status: status,
          updatedAt: activity.updatedAt
        })
      );
      await Promise.all(promises);
      this.selectedActivities = [];
      await this.loadActivities(true);
    } catch (error) {
      AppModule.handleApiError(error);
    } finally {
      this.bulkUpdating = false;
    }
  }
}
